export default [
  {
    icon: 'icon_voice_nor',
    name: '纵享好声音',
    desc: [
      {
        content: '（免费使用「超级会员专属声音」）'
      }
    ]
  },
  {
    icon: 'icon_make_nor',
    name: '随心制作',
    desc: [
      {
        content: '（'
      },
      {
        content: '80次/天',
        class: 'orange'
      },
      {
        content: '免费制作）'
      }
    ]
  },
  {
    icon: 'icon_video_nor',
    name: '视频下载',
    desc: [
      {
        content: '（视频格式下载，含字幕）'
      }
    ]
  },
  {
    icon: 'icon_soundtrack_nor',
    name: '尽享配乐',
    desc: [
      {
        content: '（解锁'
      },
      {
        content: '自定义',
        class: 'orange'
      },
      {
        content: '背景音和音效）'
      }
    ]
  },
 
  {
    icon: 'icon_discount_nor',
    name: '超优惠',
    desc: [
      {
        content: '（会员期间续费享受原价'
      },
      {
        content: 'discount',
        class: 'orange'
      },
      {
        content: '折优惠',
        class: 'orange'
      },
      {
        content: '）'
      }
    ]
  },
  {
    icon: 'icon_subtitle_nor',
    name: '同步字幕',
    desc: [
      {
        content: '（支持音频同步字幕下载）'
      }
    ]
  },
  {
    icon: 'icon_vip_nor',
    name: '会员服务',
    desc: [
      {
        content: '（专属会员服务群技巧进阶）'
      }
    ]
  },
  {
    icon: 'icon_mark_nor',
    name: '自动打轴',
    desc: [
      {
        content: '（音视频与文案一键对齐，轻松搞定字幕）'
      }
    ]
  },
  {
    icon: 'icon_sound_nor',
    name: '背景音乐搜索',
    desc: [
      {
        content: '（快速提取背景音，听歌识曲）'
      }
    ]
  },
  {
    icon: 'icon_edit_nor',
    name: '尊享音质',
    desc: [
      {
        content: '（'
      },
      {
        content: '免费赠送',
        class: 'orange'
      },
      {
        content: '48K尊享音质，限PC端使用）'
      }
    ],
    isLimitIndex:2
  }
]